import Icon from '@material-ui/icons/Map';
import React from 'react';
import { EditDialog, Filter, NestedResourceList, ResourceList, ResourceShow, SimpleShowLayout } from '../../controllers';
import { EnumField, LinkField, NumberField, TextField } from '../../fields';
import { BooleanInput, EnumInput, ReferenceInput, SearchInput } from '../../inputs';
import mission_skills from './mission_skills';

// a mission's content is edited, and missions are created, in Studio's
// builder: Houston keeps only what the builder doesn't have, the keyring
// and the skills
export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <ReferenceInput
          source="library_keyring_id"
        />
      </EditDialog>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
        filterDefaultValues={{include_unpublished: true}}
      >
        <NumberField
          source="position"
        />
        <TextField
          source="name"
        />
        <EnumField
          source="difficulty_level"
        />
        <NumberField
          source="minutes"
        />
        <NumberField
          source="points"
        />
        <NumberField
          source="coins"
        />
        <LinkField
          source="library_keyring_id"
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TextField
          source="id"
        />
        <TextField
          source="name"
        />
        <EnumField
          source="difficulty_level"
        />
        <NumberField
          source="minutes"
        />
        <NumberField
          source="points"
        />
        <NumberField
          source="coins"
        />
        <LinkField
          source="library_keyring_id"
        />
        <NumberField
          source="position"
        />

        <NestedResourceList
          reference="mission_skills"
        >
          <LinkField
            sortable={false}
            source="skill_id"
          />
          <NumberField
            source="ratio"
          />
        </NestedResourceList>
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="q"
        />
        <EnumInput
          source="difficulty_level"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
        <BooleanInput
          source="include_unpublished"
        />
      </Filter>
    ),
    Expand: props => (
      <SimpleShowLayout
        {...props}
      >
        <TextField
          source="id"
        />
        <NestedResourceList
          reference="mission_skills"
        >
          <LinkField
            sortable={false}
            source="skill_id"
          />
          <NumberField
            source="ratio"
          />
        </NestedResourceList>
      </SimpleShowLayout>
    ),
  },
  resources: {
    mission_skills,
  },
};
